/** @format */

import {
  Button,
  DialogActions,
  DialogContent,
  DialogTitle,
  Icon,
  Skeleton,
  Tooltip,
  Divider,
  Typography,
  Box,
  Modal,
} from "@mui/material";
import React, { useEffect } from "react";
import InfoIcon from "@mui/icons-material/Info";
import styled from "styled-components";
function ConfirmationModal({
  added,
  removed,
  handleSaveCoordinate,
  handleCloseConfirmationModal,
  handleOpenAddedOrRemovedModal,
  handleOpenVariableNotExist,
  missingVariablesState,
  handleOpenNegativeDimensionModal,
  negativeCoordinates,
  loader,
  checkVariableExistence,
  loadingVariableExist,
  // checkNegativeCoordinates,
  // templateData
}) {
  useEffect(() => {
    checkVariableExistence();
    // checkNegativeCoordinates(templateData);
  }, []);
  const handleShowInfo = () => {
    handleOpenAddedOrRemovedModal();
  };
  return (
    <>
      {/* <DialogContent>
        <span style={{ fontWeight: "bold" }}>
          Are you sure you want to save changes?
        </span>{" "}
        &nbsp;
        <br />
        <div style={{ display: "flex", alignItems: "flex-start" }}>
          <div>
            Added: <FontStyle style={{ fontWeight: "bold" }}>{added}</FontStyle>
            &emsp; Removed:{" "}
            <FontStyle style={{ fontWeight: "bold" }}>{removed}</FontStyle>
          </div>
          <div>
            {" "}
            <Tooltip title='Show Info'>
              <InfoIcon
                style={{
                  cursor: "pointer",
                  fontSize: "20px",
                  marginLeft: "1rem",
                }}
                onClick={() => {
                  handleShowInfo();
                }}
              />
            </Tooltip>
          </div>
        </div>
        {loadingVariableExist ? (
          <Skeleton variant='text' sx={{ fontSize: "1rem" }} />
        ) : (
          missingVariablesState?.length > 0 && (
            <span
              style={{ color: "red", display: "flex", alignItems: "center" }}
            >
              Non-Existing Variables:{" "}
              <span className='font-bold'>{missingVariablesState?.length}</span>{" "}
              <Tooltip title='Show Non-Existing Variables'>
                <InfoIcon
                  style={{
                    cursor: "pointer",
                    fontSize: "20px",
                    marginLeft: "1rem",
                  }}
                  onClick={() => {
                    handleOpenVariableNotExist();
                  }}
                />
              </Tooltip>
            </span>
          )
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={handleCloseConfirmationModal} variant='outlined'>
          Cancel
        </Button>
        <Button
          startIcon={loader && <Icon icon='eos-icons:loading' />}
          onClick={() => handleSaveCoordinate("")}
          variant='contained'
          disabled={loader}
        >
          Save
        </Button>
      </DialogActions> */}


        <Box
            sx={{
                position: "absolute",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                width: "520px",
                height: "368px",
                backgroundColor: "#fff",
                boxShadow: 24,
                overflow: "auto",
                borderRadius: "20px",
            }}
        >
            <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", p: "1em 1em  1em 2em" }}>
                <Typography variant="h6" sx={{ fontSize: "22px", fontWeight: 600, color: "#1D1D1D" }}>Exit Now</Typography>
            </Box>
            <Divider sx={{ borderWidth : "1px", margin: 0, padding: 0 }} />
            <Box sx={{ p: "1em 2em", mb: 3, display: "flex", flexDirection: "column", justifyContent: "space-between", height: "74%" }}>
                <Box>
                    <img src={`${process.env.PUBLIC_URL}/images/save_exit.gif`} alt="save_exit" style={{ height: 83 }} />
                </Box>
                <Typography variant="p" sx={{ fontSize: "18px", fontWeight: 400, color: "#1D1D1D" }}>Currently changes will be saved and you can access them later from your dashboard.</Typography>
                <Box sx={{ display: "flex", justifyContent: "space-between", mt: "auto", gap: 2 }}>
                    <Button variant="contained" sx={{ width: '183px', height: 46, color: "#185CB7", background: "transparent", textTransform: "none", fontSize: "16px", borderRadius: "10px", border: "1px solid #D2D2D2", boxShadow: "none", fontWeight: "500",}}  onClick={() => {handleSaveCoordinate("", true);}} >
                        Continue Editing
                    </Button>
                    <Button variant="contained" sx={{ width: '183px', height: 46, color: "#ffffff", background: "#185CB7", textTransform: "none", fontSize: "16px", borderRadius: "10px", border: "1px solid #185CB7", boxShadow: "none", fontWeight: "500", }} onClick={() => handleCloseConfirmationModal(true)}  >
                        Save & Exit
                    </Button>
                </Box>
            </Box>
        </Box>


    </>
  );
}

export default ConfirmationModal;

const FontStyle = styled.span`
  font-weight: bold;
`;
